import { getPythContract } from '@ui/services/contract/contract-instances/getPythContract';
import { getPythPriceFacet } from '@ui/services/contract/contract-instances/getPythPriceFacet';
import { ChainId } from '@ui/types/chain';
import { Address, keccak256, PublicClient, stringToBytes } from 'viem';

const GET_TOKEN_PYTH_ID = 'PytPriceFacet.getPythConfig';
const GET_PYTH_UPDATE_FEE = 'PytPriceFacet.getPythUpdateFee';

export const getTokenPythIdQuery = {
  getQueryKey: ({
    tokenAddress,
    clientUid,
    chainId,
  }: {
    tokenAddress: Address;
    clientUid: string;
    chainId: ChainId;
  }) => [GET_TOKEN_PYTH_ID, chainId, tokenAddress, clientUid],
  getQueryFn:
    ({
      tokenAddress,
      client,
      chainId,
    }: {
      tokenAddress: Address;
      client?: PublicClient;
      chainId: ChainId;
    }) =>
    async () => {
      if (!client) {
        throw new Error('Client missing');
      }
      const result = await getPythPriceFacet({
        publicClient: client,
        chainId,
      })?.read.getPythConfig([tokenAddress]);

      return result;
    },
};

export const getPythUpdateFee = {
  getQueryKey: ({
    pythUpdateData,
    clientUid,
    chainId,
  }: {
    pythUpdateData: string[];
    clientUid: string;
    chainId: ChainId;
  }) => [GET_PYTH_UPDATE_FEE, chainId, keccak256(stringToBytes(pythUpdateData.join())), clientUid],
  getQueryFn:
    ({
      pythUpdateData,
      client,
      chainId,
    }: {
      pythUpdateData: string[];
      client?: PublicClient;
      chainId: ChainId;
    }) =>
    async () => {
      if (!client) {
        throw new Error('Client missing');
      }
      const result = await getPythContract({
        publicClient: client,
        chainId,
      })?.read.getUpdateFee([pythUpdateData as Address[]]);

      return result;
    },
};
